module.exports = __webpack_public_path__ + "img/an-evengroup-company_logo-morado.4ccfbcf8.svg";